// Configuration for API endpoints
// Automatically detects environment and sets correct base URL

// Check if we're in development mode or on the development server
const isDevelopment = (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'development') || 
                     window.location.hostname === '172.25.225.151' ||
                     window.location.hostname === 'localhost' ||
                     window.location.hostname === '127.0.0.1';

const isLocalhost = window.location.hostname === 'localhost' || 
                   window.location.hostname === '127.0.0.1' || 
                   window.location.hostname === '172.25.225.151';

// In development (localhost), use the Flask backend port
// In production (Railway), use relative URLs since frontend and backend are served together
export const API_BASE_URL = isDevelopment && isLocalhost ? 'http://172.25.225.151:5000' : '';

// Helper function to make API calls
export const apiCall = async (endpoint, options = {}) => {
  const url = `${API_BASE_URL}${endpoint}`;
  
  console.log('API Call Debug:', {
    endpoint,
    fullUrl: url,
    isDevelopment,
    isLocalhost,
    hostname: window.location.hostname,
    API_BASE_URL
  });
  
  const defaultOptions = {
    credentials: 'include', // Important for sessions
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  };

  console.log('API Call Options:', defaultOptions);
  
  return fetch(url, defaultOptions);
};

export default API_BASE_URL; 